import { useCallback } from 'react'
import { apiPut } from '../../../../generic/Api_Functions'
import useMosInfo from '../provider/useMosInfo'

export const MACHINE_STORAGE_CHANGE_CONSUMPTION_MODE = 'MACHINE_STORAGE_CHANGE_CONSUMPTION_MODE'
export const DEFAULT_CONSUMPTION_MODE = 'FIFO'

// #39 (Bloque A): the consumption mode (FIFO/EQUILIBRADO/SELECCION) is a single value per machine,
// persisted by Sun and shared by every widget through MosInfoProvider's `machineStorage` — never
// local component state (S4). Reads default to FIFO like the server does when nothing is persisted
// (S3/S5). Writes go through `PUT mos/machineStorage/{workerId}/{deviceId}/consumptionMode` and are
// gated by the MACHINE_STORAGE_CHANGE_CONSUMPTION_MODE capability (S7, fail-secure via
// useMosInfo().hasCapability); after a successful write, `refreshActiveJobs()` re-reads
// active-context so every open widget for the machine (components + the Active Jobs widgets)
// converges on the new mode.
//
// `deviceOverride` lets callers that receive `device` as a prop instead of reading it from context
// (e.g. the components widget, ResourceListWidget) pass it explicitly.
const useConsumptionMode = (deviceOverride) => {
  const { device: contextDevice, worker, machineStorage, hasCapability, refreshActiveJobs } = useMosInfo()
  const device = deviceOverride ?? contextDevice

  const canChangeMode = typeof hasCapability === 'function'
    ? hasCapability(MACHINE_STORAGE_CHANGE_CONSUMPTION_MODE)
    : false

  const changeMode = useCallback(async (mode) => {
    if (!canChangeMode || !device?.id || !worker?.id) return
    await apiPut('mos/machineStorage/' + worker.id + '/' + device.id + '/consumptionMode', { mode })
    if (refreshActiveJobs) refreshActiveJobs()
  }, [canChangeMode, device?.id, worker?.id, refreshActiveJobs])

  return {
    mode: machineStorage?.consumptionMode ?? DEFAULT_CONSUMPTION_MODE,
    present: machineStorage?.present ?? false,
    canChangeMode,
    changeMode
  }
}

export default useConsumptionMode
